// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"MySelect_my_select_wrapper__+kaxC","my_select":"MySelect_my_select__Q0Snh"};